/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiDimensions = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.877 17.09V6.91h3.234c1.652 0 2.898.43 3.738 1.288.85.859 1.274 2.128 1.274 3.808 0 1.67-.425 2.936-1.274 3.794-.84.859-2.086 1.288-3.738 1.288H7.877zm3.206-8.737H9.627v7.294h1.456c1.083 0 1.89-.299 2.422-.896.541-.597.812-1.512.812-2.744 0-1.232-.266-2.147-.798-2.744-.532-.607-1.344-.91-2.436-.91z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPmiDimensions as PmiDimensions };
